/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-documents
 * crm-screener-documents
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ScreenerGeneratedDocumentType = {
    SummaryReport: 'summary_report',
    RulesReport: 'rules_report',
    DataPullsReport: 'data_pulls_report',
    SOffenderReport: 's_offender_report',
    MedicationsReport: 'medications_report',
    InsuranceEligibilityCheck: 'insurance_eligibility_check',
    AdvancedAiInsuranceCheck: 'advanced_ai_insurance_check',
    PalAuthSubmissionPackage: 'pal_auth_submission_package',
    PdpmReport: 'pdpm_report',
    PccFaceSheetReport: 'pcc_face_sheet_report',
    PccOrderSummaryReport: 'pcc_order_summary_report',
    PccMdHistoryReport: 'pcc_md_history_report'
} as const;
export type ScreenerGeneratedDocumentType = typeof ScreenerGeneratedDocumentType[keyof typeof ScreenerGeneratedDocumentType];


export function ScreenerGeneratedDocumentTypeFromJSON(json: any): ScreenerGeneratedDocumentType {
    return ScreenerGeneratedDocumentTypeFromJSONTyped(json, false);
}

export function ScreenerGeneratedDocumentTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScreenerGeneratedDocumentType {
    return json as ScreenerGeneratedDocumentType;
}

export function ScreenerGeneratedDocumentTypeToJSON(value?: ScreenerGeneratedDocumentType | null): any {
    return value as any;
}

